exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header.authorized {\n  background: #1b1e24;\n  width: 100%;\n  height: 60px;\n  position: fixed;\n  top: 0;\n  z-index: 200; }\n  header.authorized img.logo {\n    margin: 18px 10px;\n    float: left; }\n  header.authorized .user-panel {\n    position: relative;\n    background: #22262e;\n    float: right;\n    width: 300px;\n    height: 60px;\n    color: white;\n    padding: 10px;\n    font-weight: 300;\n    font-size: 13px;\n    line-height: 40px; }\n    header.authorized .user-panel #menu {\n      background: #22262e;\n      z-index: 9999;\n      position: absolute;\n      width: 300px;\n      left: 0px;\n      font-weight: bold;\n      border-bottom-left-radius: 10px;\n      list-style: none; }\n      header.authorized .user-panel #menu a {\n        font-weight: bold;\n        color: white;\n        text-decoration: none; }\n    header.authorized .user-panel img {\n      border-radius: 50%;\n      width: 40px;\n      height: 40px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/main/header/header.component.scss
// module id = ../../../../../src/app/main/header/header.component.scss
// module chunks = 1